export default __webpack_public_path__ + "static/media/product-image-30.6c896e81.jpg";